import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { ControlContainer, FormGroupDirective } from "@angular/forms";
import { AuthService } from "src/app/auth/auth.service";
import { Survey, AdministrativeUnitSurveyMessage } from "src/app/shared/models/survey";
import { LookupService } from "src/app/shared/services/lookup.service";

@Component({
    selector: "communication-summary",
    templateUrl: "./communication-summary.component.html",
    styleUrls: ["./communication-summary.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class CommunicationSummaryComponent implements OnInit, OnChanges {
  @Input() survey: any;
  @Input() question: any;
  @Input() badges: any = {
    "lea-messages": 0,
    "internal-notes": 0,
    "submission-history": 0,
    "action-required-comments": 0,
  };
  @Output() saveAdministrativeUnitSurveyMessage = new EventEmitter();

  get isStateUser() {
    return this.authService.isStateEducationAgencyUser;
  }

  get actionRequiredComments() {
    return this.survey.answers
      .filter((i) => i.reviewText)
      .map((i) => ({
        question: this.survey.sections
          .find((j) => j.questions.find((k) => k.id === i.questionId))
          .questions.find((k) => k.id === i.questionId),
        status: i.status,
        isActionRequired: i.isActionRequired,
        reviewDate: i.reviewDate,
        reviewedBy: i.reviewedBy,
        reviewText: i.reviewText,
      }));
  }

  get messages() {
    return this.survey.administrativeUnitSurvey &&
      this.survey.administrativeUnitSurvey.messages.length > this.survey.messages.length
      ? this.survey.administrativeUnitSurvey.messages
      : this.survey.messages || [];
  }

  get administrativeUnitSurveyHistories() {
    return (
      this.survey.administrativeUnitSurvey?.administrativeUnitSurveyHistories ||
      this.survey.administrativeUnitSurveyHistories ||
      []
    );
  }

  constructor(private authService: AuthService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    this.ngOnInit();
  }

  onNewMessage([message, isInternal]) {
    let administrativeUnitSurveyMessage: AdministrativeUnitSurveyMessage = {
      id: "",
      administrativeUnitSurveyId: "",
      commentType: "question",
      questionId: "",
      narrative: message,
      isInternal,
      isDeleted: false,
      createdOn: new Date(),
      updatedOn: new Date(),
      createdBy: {
        id: "1",
        fullName: "Acme Test User 1",
        isDeleted: false,
      },
      updatedBy: {
        id: "1",
        fullName: "Acme Test User 1",
        isDeleted: false,
      },
    };

    this.saveAdministrativeUnitSurveyMessage.emit(administrativeUnitSurveyMessage);
  }
}
